import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ProtectedRoute } from "../authentication/ProtectedRoute";
import Layout from "../components/layout/Layout";

// Pages without layout
import { LoginPage } from "../pages/login/LoginPage";
import { ForgotPasswordPage } from "../pages/forgotPassword/ForgotPasswordPage";
import { ResetPasswordPage } from "../pages/resetPassword/ResetPasswordPage";

// Pages with layout
import { DashboardPage } from "../pages/dashboard/DashboardPage";
import { TeamPage } from "../pages/team/TeamPage";
import { SupportPage } from "../pages/support/SupportPage";
import { BillingPage } from "../pages/billing/BillingPage";

/**
 * Distributor Dashboard Component
 * --------------------------
 * The Distributor Dashboard Component is responsible for rendering the entire application and its routes.
 * - Here, we define which routes are public e.g. login ect., and which are protected e.g. dashboard (aka behind login).
 * - It also determines which routes are wrappen in the layout component, which is the sidebar and topbar.
 */

const DistributorDashboard: React.FC = () => {
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Routes>
        {/* Public routes (without layout) */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/activate-account" element={<ResetPasswordPage />} />

        {/* Protected Routes (with layout) */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>

      <Toaster
        position="bottom-center"
        containerStyle={{
          zIndex: 1000,
        }}
        toastOptions={{
          duration: 4000,
          style: {
            background: "#333",
            color: "#fff",
            fontSize: "12px",
          },
        }}
      />
    </Router>
  );
};

export default DistributorDashboard;
